export { EloArrowsClockWiseIcon } from './arrows-clock-wise-icon'
